export const initiateBidForm = [
  { type: "content", title: "프로젝트", field: "project_projectname" },
  { type: "content", title: "입찰명", field: "title" },
  { type: "content", title: "예산", field: "BudgetAmount", unit: "원" },
  { type: "content", title: "예정가", field: "amount", unit: "원" },
  { type: "divider", title: "삼성중공업 담당자 정보", field: "" },
  { type: "content", title: "구매외주담당", field: "SCPerson" },
  { type: "content", title: "현장공무담당", field: "SEPerson" },
  { type: "content", title: "현장공사담당", field: "SCMPerson" },
  { type: "divider", title: "입찰공고문", field: "" },
  { type: "content", title: "입찰 개요", field: "BiddingDescription" },
  { type: "content", title: "업체 선정 기준", field: "BidderSelectMethod" },
  { type: "content", title: "입찰 유의사항", field: "BiddingGuide" },
  //
  { type: "content", title: "입찰 대상 협력사", field: "" },
  //
  { type: "divider", title: "입찰 일정 계획", field: "" },
  { type: "content", title: "사양설명회", field: "SBMDate" },
  { type: "content", title: "입찰참여회신", field: "SBMDueDate" },
  { type: "content", title: "입찰서제출기간", field: "RFBDate" },
  { type: "content", title: "결과공고일", field: "uuu_rfb_due_date2" },
  { type: "divider", title: "입찰 대상 품목정보", field: "" },
  { type: "content", title: "품목명", field: "title" },
  { type: "content", title: "수량", field: "", value: "1" },
  { type: "content", title: "단위", field: "", value: "식" },
  { type: "content", title: "예상금액", field: "amount", unit: "원" },
  { type: "content", title: "통화", field: "currencyid" },
];

export const finalizeBid1Form = [
  { type: "content", title: "프로젝트", field: "project_projectname" },
  { type: "content", title: "입찰명", field: "title" },
  { type: "content", title: "예상액", field: "amount", unit: "원" },
  { type: "content", title: "입찰개요", field: "DetailLongText" },
  { type: "divider", title: "업체선정 결과", field: "" },
  { type: "content", title: "업체선정 사유", field: "BidCancelReason" },
  { type: "divider", title: "참여 협력사 리스트", field: "" },
];
//폐찰
export const finalizeBid2Form = [
  { type: "content", title: "프로젝트", field: "project_projectname" },
  { type: "content", title: "입찰명", field: "title" },
  { type: "content", title: "예상액", field: "amount", unit: "원" },
  { type: "content", title: "입찰개요", field: "DetailLongText" },
  { type: "divider", title: "입찰현황 및 폐찰결과", field: "" },
  { type: "content", title: "폐찰사유", field: "BidCancelReason" },
  { type: "divider", title: "참여 협력사 리스트", field: "" },
];

export const contractRequestSMForm = [
  { type: "content", title: "프로젝트", field: "project_projectname" },
  { type: "content", title: "공사명", field: "SHIContractTitle" },
  { type: "divider", title: "공사개요", field: "" },
  { type: "content", title: "공종", field: "ContruntionLicense" },
  { type: "content", title: "공사기간", field: "ContractForecastDate" },
  { type: "content", title: "공사내용", field: "ContractDescription" },
  { type: "content", title: "시행사유", field: "DetailLongText" },
  { type: "divider", title: "예상 공사금액", field: "" },
  { type: "content", title: "공종", field: "BudgetAmount" },
  { type: "content", title: "도급(예상)", field: "OwnerAmount", unit: "원" },
  {
    type: "content",
    title: "견적 예산(예상)",
    field: "BudgetAmount",
    unit: "원",
  },
  { type: "divider", title: "현설 일시", field: "" },
  { type: "content", title: "일시", field: "SBMDate" },
  // { type: "content", title: "장소", field: "SBMLocation" },
  { type: "divider", title: "현설 참여 대상 업체", field: "" },
  { type: "content", title: "비고", field: "CostRemark" },
];

export const contractRequestForm = [
  { type: "content", title: "프로젝트", field: "project_projectname" },
  { type: "content", title: "공사명", field: "SHIContractTitle" },
  { type: "content", title: "계약기간", field: "ContractForecastDate" },
  { type: "content", title: "공사내용", field: "ContractDescription" },
  { type: "content", title: "시행사유", field: "DetailLongText" },
  { type: "content", title: "비고", field: "CostRemark" },
  { type: "divider", title: "협력업체 후보 리스트", field: "" },
];

export const contractForm = [
  { type: "content", title: "프로젝트", field: "project_projectname" },
  { type: "divider", title: "계약기본정보", field: "" },
  { type: "content", title: "계약번호", field: "ContractNo" },
  { type: "content", title: "계약명", field: "uconTitleSD" },
  { type: "content", title: "계약종류", field: "ContractCatPD" },
  { type: "content", title: "업체선정방식", field: "ContractMethod" },
  { type: "content", title: "계약기간", field: "ContractDate" },
  { type: "content", title: "계약내용", field: "ContractDesc" },
  { type: "divider", title: "계약 협력사 및 담당자 정보", field: "" },
  { type: "content", title: "협력사명", field: "uveVendorNameTB50" },
  { type: "content", title: "연락처", field: "uvePrimaryContactTB64" },
  { type: "content", title: "이메일", field: "uveEmailTB120" },
  { type: "divider", title: "계약대상 품목정보", field: "" },
  { type: "content", title: "품목명", field: "uconTitleSD" },
  { type: "content", title: "수량", field: "", value: "1" },
  { type: "content", title: "단위", field: "", value: "식" },
  { type: "content", title: "계약단가", field: "", value: "-" },
  { type: "content", title: "계약금액", field: "amount", unit: "원" },
  { type: "divider", title: "보증내용", field: "" },
  { type: "divider", title: "계약보증", field: "" },
  { type: "content", title: "보증금율(%)", field: "PBondRate", unit: "%" },
  { type: "content", title: "보증금액", field: "PBondAmount", unit: "원" },
  { type: "divider", title: "하자보증", field: "" },
  { type: "content", title: "보증금율(%)", field: "MBondRate", unit: "%" },
  { type: "content", title: "보증금액", field: "MBondAmount", unit: "원" },
];

export const requestChangeOrderForm = [
  { type: "content", title: "프로젝트", field: "project_projectname" },
  { type: "content", title: "계약요청건", field: "uconTitleSD" },
  { type: "content", title: "계약차수", field: "ucoCONumberIA", unit: "차" },
  { type: "content", title: "대상업체", field: "uveVendorNameTB50" },
  { type: "content", title: "계약 시작일", field: "ContractDate" },
  { type: "content", title: "계약 종료일", field: "ExpiryDate" },
  { type: "content", title: "변경 계약종료일", field: "COExpiryDate" },
  { type: "content", title: "변경 계약내용", field: "CODesc" },
  { type: "divider", title: "금액요약", field: "" },
  { type: "divider", title: "도급 금액", field: "" },
  { type: "content", title: "현재", field: "현재도급금액", unit: "원" },
  { type: "content", title: "변경", field: "변경도급금액", unit: "원" },
  { type: "content", title: "증/감", field: "증감도급금액", unit: "원" },
  { type: "divider", title: "하도급 금액", field: "" },
  { type: "content", title: "현재", field: "현재하도급금액", unit: "원" },
  { type: "content", title: "변경", field: "변경하도급금액", unit: "원" },
  { type: "content", title: "증/감", field: "증감하도급금액", unit: "원" },
  { type: "divider", title: "예산 금액", field: "" },
  { type: "content", title: "현재", field: "" },
  { type: "content", title: "변경", field: "변경예산금액", unit: "원" },
  {
    type: "content",
    title: "증/감(예산 대비 하도급)",
    field: "증감예산금액",
    unit: "%",
  },
];

export const changeOrderForm = [
  { type: "content", title: "프로젝트", field: "project_projectname" },
  { type: "divider", title: "계약기본정보", field: "" },
  { type: "content", title: "계약번호", field: "ContractNo" },
  { type: "content", title: "계약명", field: "uconTitleSD" },
  { type: "content", title: "계약종류", field: "", value: "변경계약" },
  { type: "content", title: "업체선정방식", field: "ContractMethod" },
  { type: "content", title: "계약기간", field: "ContractDate" },
  { type: "content", title: "계약내용", field: "CODesc" },
  { type: "content", title: "계약증권", field: "COBondDesc" },
  { type: "content", title: "변경계약 종료일", field: "COExpiryDate" },
  {
    type: "content",
    title: "최초계약금액 (A)",
    field: "uconOriginalContrctAmtCA",
    unit: "원",
  },
  {
    type: "content",
    title: "누적 변경 금액 (B)",
    field: "uconApprovedChangesAmtQE",
    unit: "원",
  },
  {
    type: "content",
    title: "당회 변경 신청금액 (C)",
    field: "ucoAmountofThisCoCA",
    unit: "원",
  },
  {
    type: "content",
    title: "예상 계약금액 (A+B+C)",
    field: "uconRevisedContctAmtCA",
    unit: "원",
  },
  { type: "divider", title: "계약 협력사 및 담당자 정보", field: "" },
  { type: "content", title: "협력사명", field: "uveVendorNameTB50" },
  { type: "content", title: "연락처", field: "uvePrimaryContactTB64" },
  { type: "content", title: "이메일", field: "uveEmailTB120" },
  { type: "divider", title: "계약대상 품목정보", field: "" },
  { type: "content", title: "품목명", field: "uconTitleSD" },
  { type: "content", title: "수량", field: "", value: "1" },
  { type: "content", title: "단위", field: "식", value: "식" },
  { type: "content", title: "계약단가", field: "", value: "-" },
  { type: "content", title: "계약금액", field: "amount", unit: "원" },
];

export const sapPaymentForm = [
  { type: "content", title: "프로젝트", field: "project_projectname" },
  { type: "content", title: "본문", field: "LoADescription" },
  { type: "divider", title: "공사명" },
  { type: "content", title: "도급 공사명", field: "SHIContractTitle" },
  { type: "content", title: "하도급 공사명", field: "uconTitleSD" },
  { type: "content", title: "대상업체", field: "uveVendorNameTB50" },
  { type: "content", title: "기성 지급액", field: "upaCurrPaymentDueCAS" },
  { type: "content", title: "누계보할공정률", field: "PayAppConProgress" },
  { type: "content", title: "주요공사내용", field: "PayAppWorkDesc" },
  { type: "divider", title: "기성지급현황", unit: "원" },
  {
    type: "content",
    title: "계약금액",
    field: "uconRevisedContctAmtCA",
  },
  {
    type: "content",
    title: "기 지급액",
    field: "upaSumPrevPayAppCA",
  },
  {
    type: "content",
    title: "금회기성",
    field: "upaCurrPaymentDueCA",
  },
  {
    type: "content",
    title: "누계",
    field: "upaTotalComplToDateCA",
  },
  {
    type: "content",
    title: "잔여기성",
    field: "uconRevisedContctAmtCAR",
    unit: "원",
  },
  {
    type: "content",
    title: "계약금액(%)",
    value: "100%",
  },
  {
    type: "content",
    title: "기지급액(%)",
    field: "upaSumPrevPayAppCA2",
  },
  {
    type: "content",
    title: "금회기성(%)",
    field: "upaCurrPaymentDueCA2",
  },
  {
    type: "content",
    title: "누계(%)",
    field: "upaTotalComplToDateCA2",
  },
  {
    type: "content",
    title: "잔여기성(%",
    field: "uconRevisedContctAmtCA2",
  },
  { type: "divider", title: "선급금 현황", field: "" },
  {
    type: "content",
    title: "선급금 총액",
    field: "AdvPayNetAmount",
    unit: "원",
  },
  {
    type: "content",
    title: "공제 누계액",
    field: "TotalAdvReturn",
    unit: "원",
  },
  {
    type: "content",
    title: "누계 공제율",
    field: "TotalAdvReturnPer",
    unit: "%",
  },
  {
    type: "content",
    title: "금회 공제액",
    field: "AdvReturnAmount",
    unit: "원",
  },
  {
    type: "content",
    title: "금회 공제율",
    field: "AdvReturnAmountPer",
    unit: "%",
  },
  {
    type: "content",
    title: "공제 잔여액",
    field: "ThisPeriodAdvReturn",
    unit: "원",
  },
  {
    type: "content",
    title: "공제 잔여율",
    field: "ThisPeriodAdvReturnPer",
    unit: "%",
  },
  {
    type: "content",
    title: "금회 실 지급액",
    field: "PayAppAmount",
    unit: "원",
  },
];

export const advancePaymentForm = [
  { type: "content", title: "프로젝트", field: "project_projectname" },
  { type: "content", title: "본문", field: "LoADescription" },
  { type: "content", title: "계약명", field: "uconTitleSD" },
  { type: "content", title: "계약기간", field: "ContractDate" },
  { type: "content", title: "계약업체", field: "uveVendorNameTB50" },
  {
    type: "content",
    title: "계약금액",
    field: "uconOriginalContrctAmtCA",
    unit: "원",
  },
  {
    type: "content",
    title: "선급금 (공급원가)",
    field: "AdvPayNetAmount",
    unit: "원",
  },
  { type: "content", title: "지급요청일", field: "AdvPayReqDate" },
  // { type: "divider", title: "선급금 지급 및 회수 계획", field: "" },
];

export const vendorsEvaluationForm = [
  { type: "content", title: "업체명", field: "uveVendorNameTB50" },
  { type: "content", title: "업체 유형", field: "VendorEVAType2" },
  { type: "content", title: "참여 공종", field: "VendorDisciplineMS" },
  { type: "content", title: "평가 점수", field: "EvalutionPoint" },
  { type: "content", title: "신용평가등급", field: "VendorCreditGrade" },
  { type: "content", title: "현금흐름등급", field: "VendorCashGrade" },
  { type: "content", title: "주요실적", field: "MainReference" },
];
